import { columns } from './columns';
import { DataTable } from './data-table';
import { PlannerConfigEntity } from '@/services/configurator/PlannerConfigTypes';

import { useEnv } from '@/components/providers/env-provider';
import { useEffect, useState } from 'react';
import { ConfiguratorApi } from '@/utils/ConfiguratorApi';

const LIMIT = 10;
export function PlannersTable() {
  const { env } = useEnv();
  const [offset, setOffset] = useState(0);

  const [planners, setPlanners] = useState<Array<PlannerConfigEntity>>([]);
  const [error, setError] = useState('');
  const [identifier, setIdentifier] = useState('');

  useEffect(() => {
    ConfiguratorApi.getInstance()
      .listPublisheddPlanners(env, { offset, limit: LIMIT, identifier })
      .then((result) => setPlanners(result as PlannerConfigEntity[]))
      .catch((error) => {
        console.error('Unable to list published planners', error);
        setError('Unable to fetch planners');
      });
  }, [identifier, offset, setError, setOffset, env]);

  useEffect(() => {
    setOffset(0);
  }, [identifier]);

  // advance the offset on next page
  const onNextPage = () => {
    setOffset((prev) => {
      return prev + LIMIT;
    });
  };

  // decrease the offset on previous page
  const onPreviousPage = () => {
    setOffset((prev) => {
      const newOffset = prev - LIMIT;
      return newOffset < 0 ? 0 : newOffset;
    });
  };

  const onSearch = (value: string) => {
    setIdentifier(value);
  };

  return (
    <>
      {error ? error : null}
      <DataTable
        columns={columns(env)}
        data={planners}
        onNextPage={onNextPage}
        onPreviousPage={onPreviousPage}
        nextPageDisabled={planners.length < LIMIT}
        previousPageDisabled={offset <= 0}
        onSearch={onSearch}
      />
    </>
  );
}
